import useProtectedQuery from './use-protected-query';

import RebatesClient from '../RebatesClient';

/**
 * Fetches the current user's saved statements from GET /api/report/statements.
 *
 * Returns header/list rows only (no statement lines), newest first:
 *   statements: [{ id, reference, name, scope_type, scope_label,
 *     primary_parent_account_id, primary_parent_account_name,
 *     primary_child_account_id, primary_child_account_name,
 *     invoice_count, grand_total, grand_rebate, created_at }]
 */
export default function useStatements() {
  const {
    data: statements,
    isLoading: statementsLoading,
    error: statementsError,
    refetch: refetchStatements
  } = useProtectedQuery({
    queryKey: ['statements'],
    queryFn: async () => {
      const result = await RebatesClient.getStatements();

      if (result.response.ok) {
        return result.body?.statements || [];
      }
      throw new Error('Error getting statements');
    }
  });

  return {
    statements: statements || [],
    statementsLoading,
    statementsError,
    refetchStatements
  };
}
